/*
*  Add this class to a pagination wrapper to make the pagination replace elements with unpoly
*
*  Example:
*  <div class="up-posts_wrapper">
*    several updates...
      <div class="js-unpolify_pagination"
           data-up-target=".up-posts_wrapper">
        the pagination...
      </div>
*  </div>
*/
up.compiler('.js-unpolify_pagination', function (element) {
  const target = element.dataset.upTarget
  const links = Array.from(element.querySelectorAll('a'))

  links.forEach(link => {
    link.setAttribute('up-target', target)
    link.setAttribute('up-instant', 'true')
    link.setAttribute('up-scroll', 'main')
    link.setAttribute('up-history', 'true')
  })
})
